import type { IOption } from "@components/ui-kit";
import { useGetCreditAccountOptionsQuery } from "@src/__generated__/graphql";
import { compact, flatten } from "lodash";
import type { StoreCreditAccountForm } from "./StoreCreditAccountForm";

export function useData(store: StoreCreditAccountForm) {
  const { loading, error, data } = useGetCreditAccountOptionsQuery({
    onCompleted(data) {
      store.teamOptions = data.teamSimpleMap.map((team) => ({
        label: team.name,
        value: team.id,
      }));
      store.brandOptions = flatten(
        data.clientsSimpleMap.map((c) =>
          c.brands.map((b) => ({
            label: b.name,
            value: b.id,
            client_id: parseInt(c.id),
          })),
        ),
      );
      store.expenseOptions =
        data.expenseBudgetCategories?.map((c) => ({
          label: c.name,
          value: c.id,
        })) || [];
      store.workOptions =
        data.ourWorkBudgetCategories?.map((c) => ({
          label: c.name,
          value: c.id,
        })) || [];
    },
  });

  return {
    loading,
    error,
    data,
  };
}

export const getPayloadBudgetCategoryIds = (
  payload: {
    brand_id: string;
    title: string;
    budget_category_ids: string[];
  },
  store: StoreCreditAccountForm,
  options: IOption[],
): string[] => {
  return compact(
    payload.budget_category_ids.map(
      (c) =>
        options.find(
          (o) =>
            o.label === store.budgetOptions.find((o) => o.value === c)?.label ||
            "",
        )?.value,
    ),
  );
};
